// extracted by mini-css-extract-plugin
export default {"root":"EFUBGn","TextSeparatorsMenuButtonNSkin":"rhHoTC","textSeparatorsMenuButtonNSkin":"rhHoTC","linkElement":"wIGMae","label":"aWTgIN","wrapper":"Zw7XIs"};